import styled, { css } from "styled-components";
import { responsiveWidth } from "responsive";

export const Header = styled.div<{ isScrolling: any }>`
  width: 100%;
  height: 100px;
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 99;
  transition: all 1s;
  transition-timing-function: cubic-bezier(0.46, 0.03, 0.52, 0.96);
  background-color: white;
  top: 0px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.16);

  ${({ isScrolling }) =>
    isScrolling
      ? css`
          position: fixed;
          height: 58px;
          padding: 20px;

          /* .menu__item-menu {
            top: 90px;
          } */
        `
      : ""}

  /* .menu {
    justify-content: center;
  } */

  @media screen and (max-width: 1024px) {
    height: 90px;
    padding: 20px;

    ${({ isScrolling }) =>
      isScrolling
        ? css`
            padding: 20px;
            height: 58px;
          `
        : ""}
  }
`;

export const Notices = styled.div`
  width: max-content;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 74px;
  animation: runMariQueen 10s linear forwards;

  .notice-item {
    width: fit-content;
    background-color: white;
    font-family: "SpoqaHanSansNeo-Regular";
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.46;
    letter-spacing: normal;
    text-align: left;
    color: #0d0d0d;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:nth-child(1) {
      margin-left: 74px;
    }

    &__round {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #0d0d0d;
      margin-right: 11px;

      &.secondary {
        background-color: #fddd81;
      }
      &.third {
        background-color: #8a9fd1;
      }
    }
  }
`;

export const BuyTogether = styled.div`
  padding: 161px 0px 179.7px 261px;
  background-color: #ffffff;

  @media screen and (max-width: 1440px) {
    padding: 161px 100px 179.7px 100px;
  }

  @media screen and (max-width: 1024px) {
    padding: 161px 100px 179.7px 20px;
  }

  @media screen and (max-width: 768px) {
    padding: 99px 20px 0px 20px;
  }

  @media screen and (max-width: 567px) {
    padding: 80px 15px 0px 15px;
  }
`;

export const ArtNumber = styled.div`
  ${responsiveWidth}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;

  @media (min-width: 1921px) {
    padding: 120px 0px;

    .title {
      font-weight: 800;
      font-size: 30px;
      line-height: 100%;
      letter-spacing: -0.05em;
    }

    .container-wrap {
      display: flex;
      flex-direction: column;
      gap: 37px;
      margin-top: 70px;

      .container {
        display: flex;
        gap: 100px;

        .row {
          display: flex;
          flex-direction: column;

          .title {
            font-weight: 700;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            margin-bottom: 8px;

            .sub {
              font-weight: 400;
              font-size: 12px;
              color: #9a9a9a;
              margin-left: 4px;
            }
          }

          .line1 {
            width: 185px;
            height: 1px;
            background-color: #000;
          }

          .line2 {
            width: 292px;
            height: 1px;
            background-color: #000;
          }

          .num {
            margin-top: 13px;
            font-weight: 700;
            font-size: 30px;
            line-height: 100%;
            letter-spacing: -0.05em;

            .sub {
              margin-left: 4px;
              font-weight: 400;
              font-size: 20px;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    padding: 100px 0px;

    .title {
      font-weight: 800;
      font-size: 28px;
      line-height: 100%;
      letter-spacing: -0.05em;
    }

    .container-wrap {
      display: flex;
      flex-direction: column;
      gap: 47px;
      margin-top: 60px;

      .container {
        display: flex;
        gap: 98px;

        .row {
          display: flex;
          flex-direction: column;

          .title {
            font-weight: 700;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            margin-bottom: 10px;

            .sub {
              font-weight: 400;
              font-size: 12px;
              color: #9a9a9a;
              margin-left: 4px;
            }
          }

          .line1 {
            width: 172px;
            height: 1px;
            background-color: #000;
          }

          .line2 {
            width: 272px;
            height: 1px;
            background-color: #000;
          }

          .num {
            margin-top: 8px;
            font-weight: 700;
            font-size: 28px;
            line-height: 100%;
            letter-spacing: -0.05em;

            .sub {
              margin-left: 4px;
              font-weight: 400;
              font-size: 20px;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    padding: 70px;

    .title {
      font-weight: 800;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -0.05em;
    }

    .container-wrap {
      display: flex;
      flex-direction: column;
      gap: 37px;
      margin-top: 50px;

      .container {
        display: flex;
        gap: 78px;

        .row {
          display: flex;
          flex-direction: column;

          .title {
            font-weight: 700;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: -0.05em;
            margin-bottom: 10px;

            .sub {
              font-weight: 400;
              font-size: 12px;
              color: #9a9a9a;
              margin-left: 4px;
            }
          }

          .line1 {
            width: 135px;
            height: 1px;
            background-color: #000;
          }

          .line2 {
            width: 214px;
            height: 1px;
            background-color: #000;
          }

          .num {
            margin-top: 8px;
            font-weight: 700;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;

            .sub {
              margin-left: 4px;
              font-weight: 400;
              font-size: 16px;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding: 50px 0px;

    .title {
      font-weight: 800;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: -0.05em;
      text-align: left;
    }

    .container-wrap {
      display: flex;
      flex-direction: column;
      gap: 26px;
      margin-top: 30px;

      .container {
        display: flex;
        gap: 61px;

        .row {
          display: flex;
          flex-direction: column;

          .title {
            font-weight: 700;
            font-size: 12px;
            line-height: 100%;
            letter-spacing: -0.05em;
            margin-bottom: 6px;
            color: #000;

            .sub {
              font-weight: 400;
              font-size: 10px;
              color: #9a9a9a;
              margin-left: 4px;
            }
          }

          .line1 {
            width: 120px;
            height: 1px;
            background-color: #000;
          }

          .line2 {
            width: 178px;
            height: 1px;
            background-color: #000;
          }

          .num {
            margin-top: 6px;
            font-weight: 700;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;

            .sub {
              margin-left: 4px;
              font-weight: 400;
              font-size: 12px;
              color: #9a9a9a;
            }
          }
        }
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    padding: 100px 0px;

    .title {
      font-weight: 800;
      font-size: 34px;
      line-height: 100%;
      letter-spacing: -5%;
      text-align: center;
      color: #3e3a39;
    }

    .container {
      display: flex;
      margin-top: 50px;
      flex-direction: column;
      gap: 60px;
      width: 371px;

      .sum {
        display: flex;
        flex-direction: row;
      }

      .row,
      .sum.row {
        display: flex;
        flex-direction: column;
        gap: 14px;

        .title {
          color: #a9a9a9;
          font-weight: 800;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: -0.05em;
          text-align: left;

          .sub {
            font-weight: 700;
            font-size: 16px;
            margin-left: 4px;
          }
        }

        .num {
          color: #000000;
          font-weight: 800;
          font-size: 34px;
          line-height: 100%;
          letter-spacing: -0.05em;
        }

        .sub {
          font-weight: 700;
          font-size: 22px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #9a9a9a;
          margin-left: 4px;
        }
      }
    }
  }

  @media (max-width: 567px) {
    padding: 64px 0px;

    .title {
      font-weight: 800;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #3e3a39;
    }

    .container {
      display: flex;
      margin-top: 34px;
      flex-direction: column;
      width: 242px;
      gap: 34px;

      .sum {
        display: flex;
        flex-direction: row;
      }

      .row,
      .sum.row {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .title {
          color: #a9a9a9;
          font-weight: 800;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;

          .sub {
            font-weight: 700;
            font-size: 14px;
            margin-left: 4px;
          }
        }

        .num {
          color: #000000;
          font-weight: 800;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: -0.05em;
        }

        .sub {
          font-weight: 700;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #9a9a9a;
          margin-left: 4px;
        }
      }
    }
  }
`;

export const ArtReadMore = styled.div`
  background: #f5f5f5;

  @media (min-width: 1921px) {
    padding: 130px 0px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 12px;

      .title {
        font-weight: 800;
        font-size: 30px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 218.67px;
        height: 34px;
        border-radius: 18px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    padding-top: 121px;
    padding-bottom: 126px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 10px;

      .title {
        font-weight: 800;
        font-size: 28px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 219px;
        height: 34px;
        border-radius: 18px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    padding: 106px 0px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 10px;

      .title {
        font-weight: 800;
        font-size: 22px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 123px;
        height: 28px;
        border-radius: 18px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: 93px;
    padding-bottom: 89px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 14px;

      .title {
        font-weight: 800;
        font-size: 22px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 116px;
        height: 25px;
        border-radius: 14px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    padding-top: 123px;
    padding-bottom: 127px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 10px;

      .title {
        font-weight: 800;
        font-size: 28px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 22px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 140px;
        height: 30px;
        border-radius: 16px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 567px) {
    padding-top: 70px;
    padding-bottom: 74px;

    .guid {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 8px;

      .title {
        font-weight: 800;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .content {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      button {
        width: 88px;
        height: 19px;
        border-radius: 8.25px;
        background: #653cd5;
        color: #fff;
        font-weight: 700;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: -0.05em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
`;

export const ArtTop10 = styled.div`
  ${responsiveWidth}

  @media (min-width: 1921px) {
    padding-top: 150px;
    padding-bottom: 150px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 12px;
      font-weight: 400;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 30px;
      }
    }

    .list {
      margin-top: 55px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      position: relative;
    }

    .more-btn {
      width: 50px;
      height: 50px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    padding-top: 150px;
    padding-bottom: 150px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 400;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 28px;
      }
    }

    .list {
      margin-top: 57px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      position: relative;
    }

    .more-btn {
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    padding-top: 100px;
    padding-bottom: 100px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-weight: 400;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 22px;
      }
    }

    .list {
      margin-top: 50px;
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      position: relative;
    }

    .more-btn {
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: 70px;
    padding-bottom: 70px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-weight: 400;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 22px;
      }
    }

    .list {
      margin-top: 48px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      position: relative;
    }

    .more-btn {
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    padding-top: 90px;
    padding-bottom: 90px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 12px;
      font-weight: 400;
      font-size: 22px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 34px;
      }
    }

    .list {
      margin-top: 50px;
      margin-bottom: 26px;
      display: flex;
      flex-direction: column;
      gap: 26px;
      position: relative;
    }

    .more-btn {
      width: 46px;
      height: 46px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }

  @media (max-width: 567px) {
    padding-top: 64px;
    padding-bottom: 64px;
    margin: 0 auto;
    position: relative;
    text-align: center;

    .title {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: -0.05em;
      .main {
        font-weight: 800;
        font-size: 22px;
      }
    }

    .list {
      margin-top: 50px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      position: relative;
    }

    .more-btn {
      width: 36px;
      height: 36px;
      margin: 0 auto;
      background: #f8f8f8;
      box-shadow: 0px 0px 6px 0px #00000038;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      justify-self: center;
      cursor: pointer;
    }
  }
`;
export const MiniMenuBox = styled.div<{ active?: any }>`
  height: 100px;
  background-color: #0d0d0d;

  @media (max-width: 567px) or (max-width: 1023px) {
    height: 90px;
  }
`;

export const ArtNewSletter = styled.div`
  background: #f4f4f4;

  @media (min-width: 1921px) {
    .wrapper {
      ${responsiveWidth}
      padding-top: 120px;
      padding-bottom: 78px;
      display: flex;
      flex-direction: row;
      gap: 57px;

      .img {
        width: 488px;
        height: 596px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 564px;
        height: 638px;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;

          div {
            width: 196px;
            height: 64px;
            font-weight: 800;
            font-size: 26px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 22px;
          text-align: right;
          font-weight: 800;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 6px;
            height: 10px;
            margin-left: 20px;
          }
        }
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    .wrapper {
      ${responsiveWidth}
      padding-top: 120px;
      padding-bottom: 77px;
      display: flex;
      flex-direction: row;
      gap: 48px;

      .img {
        width: 460px;
        height: 560px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 564px;
        height: 604px;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;

          div {
            width: 178px;
            height: 60px;
            font-weight: 800;
            font-size: 24px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 24px;
          text-align: right;
          font-weight: 800;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 6px;
            height: 10px;
            margin-left: 20px;
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    .wrapper {
      ${responsiveWidth}
      width: 100%;
      padding-top: 100px;
      padding-bottom: 67px;
      display: flex;
      flex-direction: row;
      gap: 30px;

      .img {
        width: 376px;
        height: 458px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 519px;
        height: 492px;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;

          div {
            width: 158px;
            height: 50px;
            font-weight: 800;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 16px;
          text-align: right;
          font-weight: 800;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 6px;
            height: 10px;
            margin-left: 20px;
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .wrapper {
      ${responsiveWidth}
      width: 100%;
      padding-top: 70px;
      padding-bottom: 38px;
      display: flex;
      flex-direction: row;
      gap: 3%;

      .img {
        width: 50%;
        height: 438px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 50%;
        height: 470px;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;

          div {
            width: 138px;
            height: 50px;
            font-weight: 800;
            font-size: 20px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 16px;
          text-align: right;
          font-weight: 700;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 5px;
            height: 6px;
            margin-left: 10px;
          }
        }
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    .wrapper {
      ${responsiveWidth}
      width: 100%;
      padding-top: 24px;
      padding-bottom: 50px;
      display: flex;
      flex-direction: column;
      gap: 20%;

      .img {
        width: 100%;
        height: 657px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 100%;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;
          margin-top: 40px;

          div {
            width: 176px;
            height: 62px;
            font-weight: 800;
            font-size: 26px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 20px;
          text-align: right;
          font-weight: 800;
          font-size: 18px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 9px;
            height: 12px;
            margin-left: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 567px) {
    .wrapper {
      ${responsiveWidth}
      width: 100%;
      padding-top: 24px;
      padding-bottom: 28px;
      display: flex;
      flex-direction: column;
      gap: 20%;

      .img {
        width: 100%;
        height: 410px;
        object-fit: contain;
        background: #e7e7e7;
      }

      .content {
        width: 100%;
        display: flex;
        flex-direction: column;

        .tabs {
          display: flex;
          flex-direction: row;
          justify-content: right;
          border-bottom: 2px solid #575757;
          margin-top: 20px;

          div {
            width: 119px;
            height: 47px;
            font-weight: 800;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -0.05em;
            background: #ebebeb;
            color: #9a9a9a;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            align-content: center;
            text-align: center;
            cursor: pointer;
          }

          .newsletter {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: 5px -2px 4px 0px #0000001f;
            }
          }

          .artInside {
            &.active {
              background: #f4f4f4;
              color: #000000;
              box-shadow: -5px -2px 4px 0px #0000001f;
            }
          }
        }

        .more-btn {
          margin-top: 20px;
          text-align: right;
          font-weight: 800;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: -0.05em;
          color: #5f5f5f;
          cursor: pointer;

          .arrow {
            width: 7px;
            height: 9px;
            margin-left: 10px;
          }
        }
      }
    }
  }
`;
